import type React from 'react'
import type { IconProps } from './types'

const HeaderIcon: React.FC<IconProps> = ({ size = 20, className = 'fill-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M5 17V7H7V11H11V7H13V17H11V13H7V17H5ZM17 17V9H15V7H19V17H17Z' />
	</svg>
)

export default HeaderIcon
